import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import '../../assets/css/galleryList.scss';

const GalleryList = ({
  galleries,
  pageIndex,
  pageSize,
  selectedId,
  galleryType,
  selectionMode,
  handleFocusRecord,
  handleOpenDetails,
  handleEditGallery,
  handleDeleteGallery,
  handleReUpload
}) => {
  const { language } = useTranslation();

  
  console.log('GalleryList rendering with galleries:', galleries, 'Gallery Type:', galleryType, 'Selection Mode:', selectionMode);

  return (
    <div className="list-container">
      <div className={`list-header ${galleryType === "evidence" ? "evidence-header" : "catalog-header"}`}>
        <div className="col-no">{language.gallery?.number || "No"}</div>
        <div className="col-images">{language.gallery?.images || "Images"}</div>
        {galleryType === "evidence" ? (
          <>
            <div className="col-case-incident">{language.gallery?.caseIncident || "Case Incident"}</div>
            <div className="col-impression-number">{language.gallery?.impressionNumber || "Impression Number"}</div>
            <div className="col-address">{language.gallery?.address || "Address"}</div>
          </>
        ) : (
          <>
            <div className="col-make">{language.gallery?.make || "Make"}</div>
            <div className="col-shoe-type">{language.gallery?.shoeType || "Shoe Type"}</div>
            <div className="col-model">{language.gallery?.model || "Model"}</div>
            <div className="col-product-code">{language.gallery?.productCode || "Product Code"}</div>
          </>
        )}
        <div className="col-actions">{language.gallery?.actions || "Actions"}</div>
      </div>
      <div className="list-body">
        {galleries.map((record, idx) => (
          <div
            key={idx}
            className={`list-row ${record.IDValue === selectedId ? 'selected' : ''} ${galleryType === "evidence" ? "evidence-row" : "catalog-row"}`}
            onClick={() => handleFocusRecord(record)}
            onDoubleClick={() => handleOpenDetails(record)}
          >
            <div className="col-no">{(pageIndex - 1) * pageSize + idx + 1}</div>
            <div className="col-images">
              <div className="image-thumbnails">
                {record.Images && record.Images.length > 0 ? (
                  record.Images.map((img, imgIdx) => (
                    <div key={imgIdx} className="thumbnail">
                      <img
                        src={img.S3RelativePath ?
                          (global.config.images3.link.endsWith("/") ?
                            `${global.config.images3.link}${img.S3RelativePath.startsWith("/") ? img.S3RelativePath.substring(1) : img.S3RelativePath}` :
                            `${global.config.images3.link}/${img.S3RelativePath.startsWith("/") ? img.S3RelativePath.substring(1) : img.S3RelativePath}`)
                          : ''}
                        alt={`${record.Make || 'Gallery'} ${record.Model || ''} - ${imgIdx + 1}`}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                      <div className="image-type-badge">
                        {img.Type || 'N/A'}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-image">
                    <i className="fa fa-image"></i>
                    <span>{language.gallery?.noImages || "No Images"}</span>
                  </div>
                )}
              </div>
            </div>
            {galleryType === "evidence" ? (
              <>
                <div className="col-case-incident">
                  {record.ImpressionInfo?.CaseIncident || 'N/A'}
                </div>
                <div className="col-impression-number">
                  {record.ImpressionInfo?.ImpressionNumber || 'N/A'}
                </div>
                <div className="col-address">
                  {record.ImpressionInfo?.LocationOfIncident || 'N/A'}
                </div>
              </>
            ) : (
              <>
                <div className="col-make">
                  {record.Make || 'N/A'}
                </div>
                <div className="col-shoe-type">
                  {record.ShoeType || 'N/A'}
                </div>
                <div className="col-model">
                  {record.Model || 'N/A'}
                </div>
                <div className="col-product-code">
                  {record.ProductCode || 'N/A'}
                </div>
              </>
            )}
            <div className="col-actions">
              {!selectionMode && (
                <div className="action-buttons">
                  <button
                    className="action-btn info-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenDetails(record);
                    }}
                    title={language.gallery?.details || "Details"}
                  >
                    <i className="fa fa-info"></i>
                  </button>
                  {galleryType === "evidence" && (
                    <>

                      <button
                        className="action-btn edit-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditGallery(record);
                        }}
                        title={language.gallery?.edit || "Edit"}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                      <button
                        className="action-btn delete-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteGallery(record);
                        }}
                        title={language.gallery?.delete || "Delete"}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </>
                  )}
                  <button
                    className="action-btn reupload-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReUpload(record);
                    }}
                    title={language.gallery?.reUpload || "Re-Upload"}
                  >
                    <i className="fa fa-upload"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryList;
